
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 34 34"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17 29.7C10 29.7 4.3 24 4.3 17S10 4.3 17 4.3 29.7 10 29.7 17 24 29.7 17 29.7zm0-23.4C11.1 6.3 6.3 11.1 6.3 17S11.1 27.7 17 27.7 27.7 22.9 27.7 17 22.9 6.3 17 6.3z","fill":"#46aea6"}}),_c('path',{attrs:{"d":"M23.2 16.2c-.2-.2-.5-.3-.8-.3h-4.3v-4.3c0-.3-.1-.6-.3-.8s-.5-.3-.8-.3c-.6 0-1.1.5-1.1 1.1v4.2h-4.3c-.6 0-1.1.5-1.1 1.1 0 .3.1.6.3.8s.5.3.8.3h4.3v4.3c0 .3.1.6.3.8s.5.3.8.3c.6 0 1.1-.5 1.1-1.1V18h4.2c.6 0 1.1-.5 1.1-1.1.1-.2 0-.5-.2-.7z","fill":"#f9aa1e"}})])
          )
        }
      }
    